/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "image": {
    "colors_default": "",
    "size_default": "aspect-default",
    "variant_default": "relative block object-cover"
  },
  "caption_colors_default": "text-gray-600",
  "caption_size_horizontal": "text-headline-xs group-[.courses]/front:hidden",
  "caption_size_vertical": "text-headline-xs group-[.bg]/box:mx-4 group-[.courses]/front:hidden",
  "caption_variant_horizontal": "break-words capitalize",
  "caption_variant_vertical": "break-words capitalize",
  "description_colors_default": "text-black",
  "description_size_horizontal": "text-body-md mt-2",
  "description_size_vertical": "text-body-xs container-col-sm-7:text-body sm:text-body mt-1 sm:container-col-lg-4:mt-2 sm:container-col-lg-7:mt-3",
  "description_variant_horizontal": "break-words",
  "description_variant_vertical": "hidden",
  "footer_colors_default": "",
  "footer_size_horizontal": "max-w-full",
  "footer_size_vertical": "max-w-full",
  "footer_variant_horizontal": "col-span-full overflow-hidden",
  "footer_variant_vertical": "overflow-hidden",
  "group_colors_default": "",
  "group_size_horizontal": "gap-0.5 col-span-2 sm:col-span-3",
  "group_size_vertical": "gap-0.5",
  "group_variant_horizontal": "flex flex-col min-w-[0]",
  "group_variant_vertical": "flex flex-col min-w-[0]",
  "header_colors_default": "",
  "header_size_horizontal": "max-w-full",
  "header_size_vertical": "max-w-full",
  "header_variant_horizontal": "col-span-2 overflow-hidden",
  "header_variant_vertical": "overflow-hidden",
  "headline_colors_default": "text-black",
  "headline_size_horizontal": "text-headline-md sm:container-col-lg-4:text-headline-sm sm:container-col-lg-7:text-headline-lg",
  "headline_size_vertical": "text-headline-sm container-col-sm-7:text-headline-sm sm:text-headline-sm sm:container-col-lg-4:text-headline-sm sm:container-col-lg-5:text-headline sm:container-col-lg-7:text-headline-lg group-[.bg]/box:mx-4 group-[.bg]/box:mb-4",
  "headline_variant_horizontal": "break-words",
  "headline_variant_vertical": "break-words",
  "colors_default": "",
  "size_horizontal": "w-full gap-6 grid-cols-2 sm:grid-cols-5",
  "size_vertical": "w-full gap-2 auto-rows-min data-[full-width]:w-screen data-[full-width]:-ml-[calc(50vw-50%)]",
  "variant_horizontal": "grid container-inline",
  "variant_vertical": "grid container-inline"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "ArticleTeaserDefault");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;